import React from 'react';
import {
  Box,
  Modal,
  IconButton,
  Typography,
  Button,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import RepeatIcon from "@mui/icons-material/Repeat";

export const ImagePreview = ({
  open,
  close,
  note,
  onDelete,
  handleFileChange,
  inputFileRef
}) => {
  const triggerFileInput = () => {
    inputFileRef.current.click();
  };

  return (
    <Modal open={open} onClose={close}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "50%",
          height: "80%",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Typography variant="h6">Vista previa de la imagen</Typography>
          <IconButton onClick={close}>
            <CloseIcon />
          </IconButton>
        </div>
        {note && (
          <>
            <img
              src={note.imagen}
              alt={note.titulo}
              style={{
                width: "100%",
                maxHeight: "70%",
                objectFit: "contain",
                marginTop: "15px",
              }}
            />
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
              <Tooltip title="Cambiar imagen">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={triggerFileInput}
                  startIcon={<RepeatIcon />}
                >
                  Cambiar
                </Button>
              </Tooltip>
              <input
                ref={inputFileRef}
                type="file"
                style={{ display: "none" }}
                onChange={(e) => handleFileChange(e, note)}
              />
              <Tooltip title="Eliminar imagen">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => onDelete(note.id_sintesis, note.cvcapsula)}
                  startIcon={<DeleteIcon />}
                >
                  Eliminar
                </Button>
              </Tooltip>
            </div>
          </>
        )}
      </Box>
    </Modal>
  );
};
